import type { ButtonProps } from '@mui/material';
import { Button } from '@mui/material';
import { createLink } from '@tanstack/react-router';
import { forwardRef } from 'react';

type ButtonLinkProps = Omit<ButtonProps<'a'>, 'component'>;

const UnwrappedButtonLink = forwardRef<HTMLAnchorElement, ButtonLinkProps>((props, ref) => (
  <Button ref={ref} component="a" {...props} />
));

export const ButtonLink = createLink(UnwrappedButtonLink);
